export const About = (props) => {
  const d = props.data;

  return (
    <div id="about">
      {/* ── Top wave from WhyChooseUs into About ── */}
      <div className="about-wave-top">
        <svg
          viewBox="0 0 1440 70"
          preserveAspectRatio="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M0,35 C480,70 960,0 1440,35 L1440,70 L0,70 Z" fill="#0f1b3d" />
        </svg>
      </div>

      <div className="container">
        {/* ── Two-column: image left, text right ── */}
        <div className="row about-main-row">
          {/* Left – image with accent frame */}
          <div className="col-md-5 col-sm-12 about-img-col">
            <div className="about-img-wrap">
              <div className="about-img-accent"></div>
              <img
                src="img/about.jpg"
                onError={(e) => {
                  e.target.src = "img/img.png";
                }}
                className="about-img"
                alt="NewGen Solar installation"
                loading="lazy"
              />
              {/* Floating badge */}
              <div className="about-badge">
                <span className="about-badge-num">8+</span>
                <span className="about-badge-label">
                  Years of
                  <br />
                  Excellence
                </span>
              </div>
            </div>
          </div>

          {/* Right – story + bullets */}
          <div className="col-md-7 col-sm-12 about-text-col">
            <div className="about-text">
              <span className="about-eyebrow">Who We Are</span>
              <h2>
                Powering India's
                <br />
                Clean Energy Future
              </h2>
              <p className="about-para">{d ? d.paragraph : "Loading…"}</p>

              <div className="about-bullets-row">
                <ul className="about-checklist">
                  {d
                    ? d.Why.map((item, i) => (
                        <li key={i}>
                          <span className="about-check">
                            <i className="fa fa-check"></i>
                          </span>
                          {item}
                        </li>
                      ))
                    : null}
                </ul>
                <ul className="about-checklist">
                  {d
                    ? d.Why2.map((item, i) => (
                        <li key={i}>
                          <span className="about-check">
                            <i className="fa fa-check"></i>
                          </span>
                          {item}
                        </li>
                      ))
                    : null}
                </ul>
              </div>

              <a
                href="#calculator"
                className="btn about-cta page-scroll"
              >
                Calculate Your Savings &nbsp;
                <i className="fa fa-arrow-right"></i>
              </a>
            </div>
          </div>
        </div>

        {/* ── Mini stats strip ── */}
        <div className="about-stats-strip">
          {[
            { icon: "fa-home", num: "1,500+", label: "Homes Powered" },
            { icon: "fa-building", num: "100+", label: "Commercial Projects" },
            { icon: "fa-map-marker", num: "7", label: "Cities Served" },
            { icon: "fa-users", num: "20+", label: "Expert Engineers" },
          ].map((s, i) => (
            <div key={i} className="about-stat-item">
              <i className={`fa ${s.icon} about-stat-icon`}></i>
              <div className="about-stat-num">{s.num}</div>
              <div className="about-stat-label">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
